import BrowserLogger from 'alife-logger'
import store from '@/store'

function alifeLogger() {
  let __bl = null
  if (process.env.VUE_APP_NODE_ENV === 'production') {
    __bl = BrowserLogger.singleton({
      pid: 'j8mut6og79@22ec624683fc08d',
      appType: 'web',
      imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
      sendResource: true,
      enableLinkTrace: true,
      behavior: true,
      enableSPA: true,
      environment: 'prod', // 仅生产环境进行上报
      setUsername: function () {
        const userInfo = store.state.user.userInfo
        const userId = userInfo?.userId || ''
        const userName = userInfo?.nickname || '-'
        const username = userId ? userId + ':' + userName : null
        return username
      }
    })
    // console.log('log __bl', __bl)
  }

  return __bl
}

export default alifeLogger
